<div class="multiselect-container">
  <div class="multiselect-header" (click)="toggleDropdown()">
    
    @if(selectedOptions.length === 0){
      <span>{{this.title}}</span>
    }

    @if(selectedOptions.length > 0){
      @if(!dropdownOpen){
        <span>{{ selectedOptions.length }} option(s) selected</span>  
      }
      @else {
        <span>{{ selectedOptions.length }} option(s) selected</span>
      }
    }

    <div class="arrow" [class.open]="dropdownOpen" (click)="toggleDropdown()"></div>
    @if(selectedOptions.length > 0 && !dropdownOpen){
      <span class="clear-selection" (click)="clearSelection($event)">x</span>
    }
  </div>

  @if(dropdownOpen){
    <ul class="options-list" style="background-color: white;">
      @for(option of options; track option){
        <li (click)="toggleSelection(option); $event.stopPropagation()">
          <input type="checkbox" [checked]="isSelected(option)">
          <span>{{ option }}</span>
        </li>
      }
    </ul>
  }
</div>